import React, { useState } from 'react';
import { FiCalendar, FiClock, FiCheckCircle, FiUser, FiMail, FiSend, FiPhone } from 'react-icons/fi';
import SeoHead from '../components/SeoHead';
import './SchedulePage.css';

const TIMES = ['09:00', '10:00', '11:00', '12:00', '14:00', '15:00', '16:00', '17:00', '18:00'];

const minDate = () => {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return d.toISOString().slice(0, 10);
};

const SchedulePage = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    date: '',
    time: '',
    topic: 'Web development',
    message: '',
  });
  const [status, setStatus] = useState({ state: 'idle', message: '' });

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setStatus({ state: 'sending', message: '' });
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ kind: 'meeting', ...form }),
      });
      if (res.ok) {
        setStatus({ state: 'success', message: 'Booked — we will confirm by email shortly.' });
        setForm({ name: '', email: '', phone: '', company: '', date: '', time: '', topic: 'Web development', message: '' });
        return;
      }
      throw new Error('failed');
    } catch {
      const subject = encodeURIComponent(`Meeting request — ${form.name || 'visitor'} · ${form.date} ${form.time}`);
      const body = encodeURIComponent(
        `Name: ${form.name}\nEmail: ${form.email}\nPhone: ${form.phone}\nCompany: ${form.company}\n\nTopic: ${form.topic}\nDate: ${form.date}\nTime: ${form.time}\n\nMessage:\n${form.message}`
      );
      window.location.href = `mailto:thinkingworld813@gmail.com?subject=${subject}&body=${body}`;
      setStatus({ state: 'fallback', message: 'Opening your email client to send the request…' });
    }
  };

  return (
    <>
      <SeoHead title="Schedule a meeting" description="Book a free 30-minute consult with THINKINGWORLD — we will confirm by email and send a calendar invite." path="/schedule" />

      <header className="page-header schedule-header">
        <div className="container">
          <span className="chip"><span className="chip-dot" /> Free 30-min consult</span>
          <h1>Schedule a meeting with Barani.</h1>
          <p>Pick a date and time that works — we will confirm by email within a few hours and send a calendar invite from <strong>thinkingworld813@gmail.com</strong>.</p>
        </div>
      </header>

      <section className="section">
        <div className="container schedule-grid">
          <aside className="schedule-side">
            <h3>What to expect</h3>
            <ul>
              <li><FiCheckCircle /> A 30-minute call — Google Meet or phone</li>
              <li><FiCheckCircle /> Quick scope &amp; budget discussion</li>
              <li><FiCheckCircle /> Honest "yes / no / referral" answer</li>
              <li><FiCheckCircle /> Written next-steps within 24 hours</li>
            </ul>

            <div className="schedule-quote">
              <p>"I personally take every discovery call. In 30 minutes we'll understand what you want to build — and you'll get an honest yes / no / referral by the end."</p>
              <strong>— Barani, Founder of THINKINGWORLD</strong>
            </div>
          </aside>

          <form className="schedule-form" onSubmit={submit}>
            <h3>Book your slot</h3>

            <div className="schedule-row">
              <label>
                <span><FiUser /> Name *</span>
                <input type="text" required value={form.name} onChange={update('name')} placeholder="Your full name" />
              </label>
              <label>
                <span><FiMail /> Email *</span>
                <input type="email" required value={form.email} onChange={update('email')} placeholder="you@company.com" />
              </label>
            </div>

            <div className="schedule-row">
              <label>
                <span><FiPhone /> Phone / WhatsApp</span>
                <input type="tel" value={form.phone} onChange={update('phone')} placeholder="+91…" />
              </label>
              <label>
                <span>Company</span>
                <input type="text" value={form.company} onChange={update('company')} placeholder="Optional" />
              </label>
            </div>

            <div className="schedule-row">
              <label>
                <span><FiCalendar /> Preferred date *</span>
                <input type="date" required min={minDate()} value={form.date} onChange={update('date')} />
              </label>
              <label>
                <span><FiClock /> Preferred time *</span>
                <select required value={form.time} onChange={update('time')}>
                  <option value="">Pick a slot</option>
                  {TIMES.map((t) => <option key={t} value={t}>{t} IST</option>)}
                </select>
              </label>
            </div>

            <label className="schedule-row-full">
              <span>What would you like to discuss?</span>
              <select value={form.topic} onChange={update('topic')}>
                <option>Web development</option>
                <option>Mobile app</option>
                <option>IoT solution</option>
                <option>Digital marketing &amp; SEO</option>
                <option>AI integration</option>
                <option>Audit / consultation</option>
                <option>Other</option>
              </select>
            </label>

            <label className="schedule-row-full">
              <span>Anything we should know before the call?</span>
              <textarea
                rows="4"
                value={form.message}
                onChange={update('message')}
                placeholder="Optional — share context that will make the call more productive."
              />
            </label>

            <button type="submit" className="btn btn-accent" disabled={status.state === 'sending'}>
              {status.state === 'sending' ? 'Booking…' : (<><FiSend /> Request meeting</>)}
            </button>

            {status.state === 'success' && (
              <p className="contact-status contact-status--ok"><FiCheckCircle /> {status.message}</p>
            )}
            {status.state === 'fallback' && (
              <p className="contact-status contact-status--info">{status.message}</p>
            )}
          </form>
        </div>
      </section>
    </>
  );
};

export default SchedulePage;
